import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminContainersByContainerKeyEntities: build.query<
      GetV2AdminContainersByContainerKeyEntitiesApiResponse,
      GetV2AdminContainersByContainerKeyEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/containers/${queryArg.containerKey}/entities`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          user_id: queryArg.userId,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2AdminContainersByContainerKeyEntitiesAndEntityId: build.query<
      GetV2AdminContainersByContainerKeyEntitiesAndEntityIdApiResponse,
      GetV2AdminContainersByContainerKeyEntitiesAndEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/containers/${queryArg.containerKey}/entities/${queryArg.entityId}`,
        params: {
          user_id: queryArg.userId,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    getV2AdminContainersByContainerKeyEntitiesAndEntityIdComponentsTypeKey:
      build.query<
        GetV2AdminContainersByContainerKeyEntitiesAndEntityIdComponentsTypeKeyApiResponse,
        GetV2AdminContainersByContainerKeyEntitiesAndEntityIdComponentsTypeKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/containers/${queryArg.containerKey}/entities/${queryArg.entityId}/components/${queryArg.typeKey}`,
          params: {
            page: queryArg.page,
            per_page: queryArg.perPage,
            user_id: queryArg.userId,
            organization_id: queryArg.organizationId,
          },
        }),
      }),
    getV2ProviderContainersByContainerKey: build.query<
      GetV2ProviderContainersByContainerKeyApiResponse,
      GetV2ProviderContainersByContainerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/containers/${queryArg.containerKey}`,
        params: {
          entity_id: queryArg.entityId,
        },
      }),
    }),
    getV2ProviderContainersByContainerKeyComponentsAndTypeKey: build.query<
      GetV2ProviderContainersByContainerKeyComponentsAndTypeKeyApiResponse,
      GetV2ProviderContainersByContainerKeyComponentsAndTypeKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/containers/${queryArg.containerKey}/components/${queryArg.typeKey}`,
        params: {
          entity_id: queryArg.entityId,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    postV2ProviderContainersByContainerKeyComponentsAndTypeKeyActionsActionKey:
      build.mutation<
        PostV2ProviderContainersByContainerKeyComponentsAndTypeKeyActionsActionKeyApiResponse,
        PostV2ProviderContainersByContainerKeyComponentsAndTypeKeyActionsActionKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/containers/${queryArg.containerKey}/components/${queryArg.typeKey}/actions/${queryArg.actionKey}`,
          method: "POST",
          body: queryArg.tileActionRequest,
        }),
      }),
    postV2ProviderContainersByContainerKeyComponentsAndTypeKeyDismiss:
      build.mutation<
        PostV2ProviderContainersByContainerKeyComponentsAndTypeKeyDismissApiResponse,
        PostV2ProviderContainersByContainerKeyComponentsAndTypeKeyDismissApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/containers/${queryArg.containerKey}/components/${queryArg.typeKey}/dismiss`,
          method: "POST",
          params: {
            entity_id: queryArg.entityId,
            tile_id: queryArg.tileId,
          },
        }),
      }),
    getV2ProviderPatientsByPatientIdPageV3Bootstrap: build.query<
      GetV2ProviderPatientsByPatientIdPageV3BootstrapApiResponse,
      GetV2ProviderPatientsByPatientIdPageV3BootstrapApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/page-v3/bootstrap`,
      }),
    }),
    getV2ProviderPatientsByPatientIdPageV3Encounters: build.query<
      GetV2ProviderPatientsByPatientIdPageV3EncountersApiResponse,
      GetV2ProviderPatientsByPatientIdPageV3EncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/page-v3/encounters`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2ProviderPatientsByPatientIdPageV3EncountersBilling: build.query<
      GetV2ProviderPatientsByPatientIdPageV3EncountersBillingApiResponse,
      GetV2ProviderPatientsByPatientIdPageV3EncountersBillingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/page-v3/encounters/billing`,
        params: {
          encounter_ids: queryArg.encounterIds,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminContainersByContainerKeyEntitiesApiResponse =
  /** status 200 OK */ ListResponseAdminContainerEntityItem;
export type GetV2AdminContainersByContainerKeyEntitiesApiArg = {
  containerKey: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Provider user ID whose containers to inspect */
  userId: string;
  /** Organization ID */
  organizationId: string;
};
export type GetV2AdminContainersByContainerKeyEntitiesAndEntityIdApiResponse =
  /** status 200 OK */ AdminContainerDetailResponse;
export type GetV2AdminContainersByContainerKeyEntitiesAndEntityIdApiArg = {
  containerKey: string;
  entityId: string;
  /** Provider user ID whose containers to inspect */
  userId: string;
  /** Organization ID */
  organizationId: string;
};
export type GetV2AdminContainersByContainerKeyEntitiesAndEntityIdComponentsTypeKeyApiResponse =
  /** status 200 OK */ ListResponseAdminComponentDetailResponse;
export type GetV2AdminContainersByContainerKeyEntitiesAndEntityIdComponentsTypeKeyApiArg =
  {
    containerKey: string;
    entityId: string;
    typeKey: string;
    /** Page number (1-based) */
    page?: number;
    /** Items per page (max 1000) */
    perPage?: number;
    /** Provider user ID whose containers to inspect */
    userId: string;
    /** Organization ID */
    organizationId: string;
  };
export type GetV2ProviderContainersByContainerKeyApiResponse =
  /** status 200 OK */ ContainerResponse;
export type GetV2ProviderContainersByContainerKeyApiArg = {
  containerKey: string;
  /** Entity scoping ID (e.g. patient_id) */
  entityId?: string | null;
};
export type GetV2ProviderContainersByContainerKeyComponentsAndTypeKeyApiResponse =
  /** status 200 OK */ ComponentResponse2;
export type GetV2ProviderContainersByContainerKeyComponentsAndTypeKeyApiArg = {
  containerKey: string;
  typeKey: string;
  /** Entity scoping ID (e.g. patient_id) */
  entityId?: string | null;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 100) */
  perPage?: number;
};
export type PostV2ProviderContainersByContainerKeyComponentsAndTypeKeyActionsActionKeyApiResponse =
  /** status 200 OK */ TileActionResponse;
export type PostV2ProviderContainersByContainerKeyComponentsAndTypeKeyActionsActionKeyApiArg =
  {
    containerKey: string;
    typeKey: string;
    actionKey: string;
    tileActionRequest: TileActionRequest;
  };
export type PostV2ProviderContainersByContainerKeyComponentsAndTypeKeyDismissApiResponse =
  /** status 200 OK */ DismissResponse;
export type PostV2ProviderContainersByContainerKeyComponentsAndTypeKeyDismissApiArg =
  {
    containerKey: string;
    typeKey: string;
    /** Entity scoping ID (e.g. patient_id) */
    entityId?: string | null;
    /** Tile ID within a tile_row component */
    tileId?: string | null;
  };
export type GetV2ProviderPatientsByPatientIdPageV3BootstrapApiResponse =
  /** status 200 OK */ PatientPageV3Bootstrap;
export type GetV2ProviderPatientsByPatientIdPageV3BootstrapApiArg = {
  patientId: string;
};
export type GetV2ProviderPatientsByPatientIdPageV3EncountersApiResponse =
  /** status 200 OK */ PatientPageV3EncounterListResponse;
export type GetV2ProviderPatientsByPatientIdPageV3EncountersApiArg = {
  patientId: string;
  page?: number;
  perPage?: number;
  sortOrder?: "asc" | "desc";
};
export type GetV2ProviderPatientsByPatientIdPageV3EncountersBillingApiResponse =
  /** status 200 OK */ PatientPageV3EncounterBillingResponse;
export type GetV2ProviderPatientsByPatientIdPageV3EncountersBillingApiArg = {
  patientId: string;
  encounterIds: string;
};
export type AdminContainerEntityItem = {
  assembled_at?: string | null;
  component_count?: number;
  entity_id: string;
  stale?: boolean;
};
export type ListResponseAdminContainerEntityItem = {
  items: AdminContainerEntityItem[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type AdminComponentSummary = {
  component_id?: string | null;
  data?: {
    [key: string]: any;
  } | null;
  generated_at?: string | null;
  stale?: boolean;
  type_key: string;
};
export type AdminContainerDetailResponse = {
  assembled_at?: string | null;
  components: AdminComponentSummary[];
  container_key: string;
  entity_id: string;
  layout: {
    [key: string]: any;
  };
  stale?: boolean;
};
export type AdminComponentDetailResponse = {
  component_id?: string | null;
  container_key: string;
  data?: {
    [key: string]: any;
  } | null;
  entity_id: string;
  generated_at?: string | null;
  stale?: boolean;
  type_key: string;
};
export type ListResponseAdminComponentDetailResponse = {
  items: AdminComponentDetailResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ActionCardData = {
  cta_label: string;
  detail?: string | null;
  headline: string;
  primitive?: "action_card";
  variant?: string | null;
};
export type BannerData = {
  primitive?: "banner";
  severity: string;
  text: string;
};
export type ChartPoint = {
  x: string;
  y?: number | null;
};
export type ChartSeries = {
  name: string;
  points?: ChartPoint[];
};
export type ChartData = {
  goal_line?: number | null;
  markers?:
    | {
        [key: string]: any;
      }[]
    | null;
  primitive?: "chart";
  series: ChartSeries[];
  title?: string | null;
};
export type ClinicalChartAllergy = {
  allergen: string;
  allergy_id: string;
  date_added?: string | null;
  is_active?: boolean;
  onset_date?: string | null;
  reaction?: string | null;
  severity?: string | null;
};
export type ClinicalChartDiagnosis = {
  code?: string | null;
  date_added?: string | null;
  diagnosis_id: string;
  end_date?: string | null;
  is_active?: boolean;
  name: string;
  status: string;
};
export type ClinicalChartMedication = {
  date_prescribed?: string | null;
  dosage?: string | null;
  end_date?: string | null;
  form?: string | null;
  frequency?: string | null;
  generic_name?: string | null;
  indication?: string | null;
  is_active?: boolean;
  medication_id: string;
  name: string;
  route?: string | null;
  start_date?: string | null;
  status: string;
  strength?: string | null;
  timing?: string | null;
};
export type ClinicalChartData = {
  allergies?: ClinicalChartAllergy[];
  diagnoses?: ClinicalChartDiagnosis[];
  medications?: ClinicalChartMedication[];
  primitive?: "clinical_chart";
};
export type DomainPayloadData = {
  primitive?: "domain_payload";
  [key: string]: any;
};
export type KeyFact = {
  label: string;
  value: string;
};
export type HeaderData = {
  demographics?: string | null;
  key_facts?: KeyFact[];
  name: string;
  primitive?: "header";
};
export type ConsentEnvelope = {
  consent_stale?: boolean;
  consented_at?: string | null;
  state: "unavailable" | "needed" | "pulling" | "granted";
};
export type Action = {
  kind: "navigate" | "modal" | "chat_scope" | "dismiss" | "noop";
  label: string;
  payload?: {
    [key: string]: any;
  } | null;
  target?: string | null;
};
export type ItemListItem = {
  actions?: Action[];
  date?: string | null;
  detail?: string | null;
  label: string;
  status?: string | null;
  type?: string | null;
};
export type ItemListData = {
  consent?: ConsentEnvelope | null;
  filters?: string[] | null;
  items: ItemListItem[];
  page?: number | null;
  per_page?: number | null;
  primitive?: "item_list";
  total?: number | null;
};
export type KeyValueRow = {
  extra?: string | null;
  label: string;
  status?: string | null;
  value: string;
};
export type KeyValueGridData = {
  primitive?: "key_value_grid";
  rows: KeyValueRow[];
};
export type FeedbackConfig = {
  content_type: string;
  current_value?: ("positive" | "negative") | null;
};
export type Tag = {
  label: string;
  variant?: string | null;
};
export type TextBlockData = {
  actions?: Action[];
  body: string;
  feedback?: FeedbackConfig | null;
  primitive?: "text_block";
  subtitle?: string | null;
  tags?: Tag[] | null;
  title?: string | null;
};
export type TileAction = {
  action_key: string;
  label: string;
};
export type Tile = {
  actions?: TileAction[];
  chat_scope?: {
    [key: string]: any;
  } | null;
  detail?: string | null;
  feedback?: FeedbackConfig | null;
  headline: string;
  id: string;
  label?: string | null;
  signal_type?: string | null;
  tile_type?: string | null;
  variant: string;
};
export type TileRowData = {
  primitive?: "tile_row";
  tiles: Tile[];
};
export type ComponentResponse = {
  data?:
    | (
        | ({
            primitive: "action_card";
          } & ActionCardData)
        | ({
            primitive: "banner";
          } & BannerData)
        | ({
            primitive: "chart";
          } & ChartData)
        | ({
            primitive: "clinical_chart";
          } & ClinicalChartData)
        | ({
            primitive: "domain_payload";
          } & DomainPayloadData)
        | ({
            primitive: "header";
          } & HeaderData)
        | ({
            primitive: "item_list";
          } & ItemListData)
        | ({
            primitive: "key_value_grid";
          } & KeyValueGridData)
        | ({
            primitive: "text_block";
          } & TextBlockData)
        | ({
            primitive: "tile_row";
          } & TileRowData)
      )
    | null;
  delivery: "inline" | "lazy";
  endpoint?: string | null;
  placeholder?: {
    [key: string]: any;
  } | null;
  primitive:
    | "header"
    | "key_value_grid"
    | "clinical_chart"
    | "item_list"
    | "chart"
    | "text_block"
    | "tile_row"
    | "banner"
    | "action_card"
    | "domain_payload";
  type_key: string;
};
export type SectionResponse = {
  components: ComponentResponse[];
  key: string;
  subtitle?: string | null;
  title: string;
};
export type ContainerResponse = {
  container_key: string;
  entity_id?: string | null;
  sections: SectionResponse[];
  stale?: boolean;
  top_level: ComponentResponse[];
};
export type ActionCardData2 = {
  cta_label: string;
  detail?: string | null;
  headline: string;
  primitive?: "action_card";
  variant?: string | null;
};
export type BannerData2 = {
  primitive?: "banner";
  severity: string;
  text: string;
};
export type ChartPoint2 = {
  x: string;
  y?: number | null;
};
export type ChartSeries2 = {
  name: string;
  points?: ChartPoint2[];
};
export type ChartData2 = {
  goal_line?: number | null;
  markers?:
    | {
        [key: string]: any;
      }[]
    | null;
  primitive?: "chart";
  series: ChartSeries2[];
  title?: string | null;
};
export type ClinicalChartAllergy2 = {
  allergen: string;
  allergy_id: string;
  date_added?: string | null;
  is_active?: boolean;
  onset_date?: string | null;
  reaction?: string | null;
  severity?: string | null;
};
export type ClinicalChartDiagnosis2 = {
  code?: string | null;
  date_added?: string | null;
  diagnosis_id: string;
  end_date?: string | null;
  is_active?: boolean;
  name: string;
  status: string;
};
export type ClinicalChartMedication2 = {
  date_prescribed?: string | null;
  dosage?: string | null;
  end_date?: string | null;
  form?: string | null;
  frequency?: string | null;
  generic_name?: string | null;
  indication?: string | null;
  is_active?: boolean;
  medication_id: string;
  name: string;
  route?: string | null;
  start_date?: string | null;
  status: string;
  strength?: string | null;
  timing?: string | null;
};
export type ClinicalChartData2 = {
  allergies?: ClinicalChartAllergy2[];
  diagnoses?: ClinicalChartDiagnosis2[];
  medications?: ClinicalChartMedication2[];
  primitive?: "clinical_chart";
};
export type DomainPayloadData2 = {
  primitive?: "domain_payload";
  [key: string]: any;
};
export type KeyFact2 = {
  label: string;
  value: string;
};
export type HeaderData2 = {
  demographics?: string | null;
  key_facts?: KeyFact2[];
  name: string;
  primitive?: "header";
};
export type ConsentEnvelope2 = {
  consent_stale?: boolean;
  consented_at?: string | null;
  state: "unavailable" | "needed" | "pulling" | "granted";
};
export type Action2 = {
  kind: "navigate" | "modal" | "chat_scope" | "dismiss" | "noop";
  label: string;
  payload?: {
    [key: string]: any;
  } | null;
  target?: string | null;
};
export type ItemListItem2 = {
  actions?: Action2[];
  date?: string | null;
  detail?: string | null;
  label: string;
  status?: string | null;
  type?: string | null;
};
export type ItemListData2 = {
  consent?: ConsentEnvelope2 | null;
  filters?: string[] | null;
  items: ItemListItem2[];
  page?: number | null;
  per_page?: number | null;
  primitive?: "item_list";
  total?: number | null;
};
export type KeyValueRow2 = {
  extra?: string | null;
  label: string;
  status?: string | null;
  value: string;
};
export type KeyValueGridData2 = {
  primitive?: "key_value_grid";
  rows: KeyValueRow2[];
};
export type FeedbackConfig2 = {
  content_type: string;
  current_value?: ("positive" | "negative") | null;
};
export type Tag2 = {
  label: string;
  variant?: string | null;
};
export type TextBlockData2 = {
  actions?: Action2[];
  body: string;
  feedback?: FeedbackConfig2 | null;
  primitive?: "text_block";
  subtitle?: string | null;
  tags?: Tag2[] | null;
  title?: string | null;
};
export type TileAction2 = {
  action_key: string;
  label: string;
};
export type Tile2 = {
  actions?: TileAction2[];
  chat_scope?: {
    [key: string]: any;
  } | null;
  detail?: string | null;
  feedback?: FeedbackConfig2 | null;
  headline: string;
  id: string;
  label?: string | null;
  signal_type?: string | null;
  tile_type?: string | null;
  variant: string;
};
export type TileRowData2 = {
  primitive?: "tile_row";
  tiles: Tile2[];
};
export type ComponentResponse2 = {
  data?:
    | (
        | ({
            primitive: "action_card";
          } & ActionCardData2)
        | ({
            primitive: "banner";
          } & BannerData2)
        | ({
            primitive: "chart";
          } & ChartData2)
        | ({
            primitive: "clinical_chart";
          } & ClinicalChartData2)
        | ({
            primitive: "domain_payload";
          } & DomainPayloadData2)
        | ({
            primitive: "header";
          } & HeaderData2)
        | ({
            primitive: "item_list";
          } & ItemListData2)
        | ({
            primitive: "key_value_grid";
          } & KeyValueGridData2)
        | ({
            primitive: "text_block";
          } & TextBlockData2)
        | ({
            primitive: "tile_row";
          } & TileRowData2)
      )
    | null;
  delivery: "inline" | "lazy";
  endpoint?: string | null;
  placeholder?: {
    [key: string]: any;
  } | null;
  primitive:
    | "header"
    | "key_value_grid"
    | "clinical_chart"
    | "item_list"
    | "chart"
    | "text_block"
    | "tile_row"
    | "banner"
    | "action_card"
    | "domain_payload";
  type_key: string;
};
export type TileActionResponse = {
  action_id: string;
  action_key: string;
  remaining_tiles: number;
  state: string;
  tile_id: string;
};
export type TileActionRequest = {
  /** Entity scoping ID (e.g. patient_id) */
  entity_id: string;
  /** ID of the tile to act on */
  tile_id: string;
};
export type DismissResponse = {
  dismissed: boolean;
  remaining_tiles?: number | null;
  tile_id?: string | null;
  type_key: string;
};
export type PatientPageV3Capabilities = {
  can_delete: boolean;
  can_edit_profile: boolean;
  can_export: boolean;
  can_read: boolean;
  can_record: boolean;
  can_schedule: boolean;
  can_use_assistant: boolean;
};
export type PatientPageV3HeaderActions = {
  can_delete: boolean;
  can_edit_profile: boolean;
  can_export: boolean;
};
export type PatientPageV3ContactHeader = {
  available: boolean;
  email: string | null;
  phone: string | null;
};
export type PatientPageV3EligibilitySummary = {
  available: boolean;
  last_checked_at: string | null;
  pinned_context: string | null;
  readiness_label: string | null;
  status_light: ("green" | "yellow" | "red" | "unknown") | null;
};
export type PatientPageV3CoverageGap = {
  end: string | null;
  start: string;
};
export type PatientPageV3CoverageHeader = {
  available: boolean;
  eligibility: PatientPageV3EligibilitySummary;
  in_force_today: boolean | null;
  incoming_effective_date: string | null;
  mode: ("insurance" | "self_pay" | "other" | "none") | null;
  next_gap: PatientPageV3CoverageGap | null;
  primary_payer_label: string | null;
};
export type PatientPageV3DemographicsHeader = {
  age: number | null;
  dob: string | null;
  dob_missing: boolean;
  gender: string | null;
  gender_missing: boolean;
  pronouns: string | null;
};
export type PatientPageV3FinancialHeader = {
  available: boolean;
  balance_cents: number | null;
  due_status: string | null;
};
export type PatientPageV3IdentityHeader = {
  display_name: string;
  identifier: string | null;
  initials_seed: string;
  preferred_name: string | null;
};
export type PatientPageV3VisitHeader = {
  appointment_id: string | null;
  available: boolean;
  can_record: boolean;
  can_schedule: boolean;
  starts_at: string | null;
  status: string | null;
};
export type PatientPageV3Header = {
  actions: PatientPageV3HeaderActions;
  contact: PatientPageV3ContactHeader;
  coverage: PatientPageV3CoverageHeader;
  demographics: PatientPageV3DemographicsHeader;
  financial: PatientPageV3FinancialHeader;
  identity: PatientPageV3IdentityHeader;
  visit: PatientPageV3VisitHeader;
};
export type ActionCardData3 = {
  cta_label: string;
  detail?: string | null;
  headline: string;
  primitive?: "action_card";
  variant?: string | null;
};
export type BannerData3 = {
  primitive?: "banner";
  severity: string;
  text: string;
};
export type ChartPoint3 = {
  x: string;
  y?: number | null;
};
export type ChartSeries3 = {
  name: string;
  points?: ChartPoint3[];
};
export type ChartData3 = {
  goal_line?: number | null;
  markers?:
    | {
        [key: string]: any;
      }[]
    | null;
  primitive?: "chart";
  series: ChartSeries3[];
  title?: string | null;
};
export type ClinicalChartAllergy3 = {
  allergen: string;
  allergy_id: string;
  date_added?: string | null;
  is_active?: boolean;
  onset_date?: string | null;
  reaction?: string | null;
  severity?: string | null;
};
export type ClinicalChartDiagnosis3 = {
  code?: string | null;
  date_added?: string | null;
  diagnosis_id: string;
  end_date?: string | null;
  is_active?: boolean;
  name: string;
  status: string;
};
export type ClinicalChartMedication3 = {
  date_prescribed?: string | null;
  dosage?: string | null;
  end_date?: string | null;
  form?: string | null;
  frequency?: string | null;
  generic_name?: string | null;
  indication?: string | null;
  is_active?: boolean;
  medication_id: string;
  name: string;
  route?: string | null;
  start_date?: string | null;
  status: string;
  strength?: string | null;
  timing?: string | null;
};
export type ClinicalChartData3 = {
  allergies?: ClinicalChartAllergy3[];
  diagnoses?: ClinicalChartDiagnosis3[];
  medications?: ClinicalChartMedication3[];
  primitive?: "clinical_chart";
};
export type DomainPayloadData3 = {
  primitive?: "domain_payload";
  [key: string]: any;
};
export type KeyFact3 = {
  label: string;
  value: string;
};
export type HeaderData3 = {
  demographics?: string | null;
  key_facts?: KeyFact3[];
  name: string;
  primitive?: "header";
};
export type ConsentEnvelope3 = {
  consent_stale?: boolean;
  consented_at?: string | null;
  state: "unavailable" | "needed" | "pulling" | "granted";
};
export type Action3 = {
  kind: "navigate" | "modal" | "chat_scope" | "dismiss" | "noop";
  label: string;
  payload?: {
    [key: string]: any;
  } | null;
  target?: string | null;
};
export type ItemListItem3 = {
  actions?: Action3[];
  date?: string | null;
  detail?: string | null;
  label: string;
  status?: string | null;
  type?: string | null;
};
export type ItemListData3 = {
  consent?: ConsentEnvelope3 | null;
  filters?: string[] | null;
  items: ItemListItem3[];
  page?: number | null;
  per_page?: number | null;
  primitive?: "item_list";
  total?: number | null;
};
export type KeyValueRow3 = {
  extra?: string | null;
  label: string;
  status?: string | null;
  value: string;
};
export type KeyValueGridData3 = {
  primitive?: "key_value_grid";
  rows: KeyValueRow3[];
};
export type FeedbackConfig3 = {
  content_type: string;
  current_value?: ("positive" | "negative") | null;
};
export type Tag3 = {
  label: string;
  variant?: string | null;
};
export type TextBlockData3 = {
  actions?: Action3[];
  body: string;
  feedback?: FeedbackConfig3 | null;
  primitive?: "text_block";
  subtitle?: string | null;
  tags?: Tag3[] | null;
  title?: string | null;
};
export type TileAction3 = {
  action_key: string;
  label: string;
};
export type Tile3 = {
  actions?: TileAction3[];
  chat_scope?: {
    [key: string]: any;
  } | null;
  detail?: string | null;
  feedback?: FeedbackConfig3 | null;
  headline: string;
  id: string;
  label?: string | null;
  signal_type?: string | null;
  tile_type?: string | null;
  variant: string;
};
export type TileRowData3 = {
  primitive?: "tile_row";
  tiles: Tile3[];
};
export type ComponentResponse3 = {
  data?:
    | (
        | ({
            primitive: "action_card";
          } & ActionCardData3)
        | ({
            primitive: "banner";
          } & BannerData3)
        | ({
            primitive: "chart";
          } & ChartData3)
        | ({
            primitive: "clinical_chart";
          } & ClinicalChartData3)
        | ({
            primitive: "domain_payload";
          } & DomainPayloadData3)
        | ({
            primitive: "header";
          } & HeaderData3)
        | ({
            primitive: "item_list";
          } & ItemListData3)
        | ({
            primitive: "key_value_grid";
          } & KeyValueGridData3)
        | ({
            primitive: "text_block";
          } & TextBlockData3)
        | ({
            primitive: "tile_row";
          } & TileRowData3)
      )
    | null;
  delivery: "inline" | "lazy";
  endpoint?: string | null;
  placeholder?: {
    [key: string]: any;
  } | null;
  primitive:
    | "header"
    | "key_value_grid"
    | "clinical_chart"
    | "item_list"
    | "chart"
    | "text_block"
    | "tile_row"
    | "banner"
    | "action_card"
    | "domain_payload";
  type_key: string;
};
export type PatientIntelligenceState = {
  component: ComponentResponse3 | null;
  displayable: boolean;
  generated_at: string | null;
  source_encounter_id: string | null;
  state: "ready" | "none" | "not_generated" | "stale" | "unavailable";
};
export type PatientSectionBadge = {
  label: string;
  tone: "neutral" | "info" | "warning" | "critical";
};
export type PatientSectionPlaceholder = {
  estimated_height: number;
  variant:
    | "tiles"
    | "workspace"
    | "cards"
    | "chart"
    | "record"
    | "list"
    | "profile"
    | "billing";
};
export type PatientPageSectionDescriptor = {
  badge: PatientSectionBadge | null;
  capabilities: (
    | "read"
    | "add"
    | "edit"
    | "delete"
    | "send"
    | "run_check"
    | "record_payment"
    | "upload"
    | "export"
    | "schedule"
    | "record"
    | "prescribe"
    | "use_assistant"
  )[];
  endpoint: string | null;
  inline_component: ComponentResponse3 | null;
  instance_key: string;
  load_policy: "eager" | "near_viewport" | "viewport_or_intent";
  nav_label: string;
  payload_mode: "inline" | "section_endpoint" | "domain_query";
  placeholder: PatientSectionPlaceholder;
  renderer_key:
    | "patient_attention"
    | "patient_insurance"
    | "patient_medications"
    | "patient_diagnoses"
    | "patient_allergies"
    | "patient_assessments"
    | "patient_care_record"
    | "patient_profile_contacts"
    | "patient_encounters"
    | "patient_forms"
    | "patient_documents"
    | "patient_billing"
    | "patient_requirements";
  section_key: string;
  subtitle: string | null;
  title: string;
};
export type PatientPageV3Bootstrap = {
  capabilities: PatientPageV3Capabilities;
  container_key: "patient_page_v3";
  generated_at: string;
  header: PatientPageV3Header;
  intelligence: PatientIntelligenceState;
  patient_id: string;
  revision: string;
  schema_version: "1";
  sections: PatientPageSectionDescriptor[];
};
export type PatientPageV3EncounterRow = {
  analysis_tags: string[];
  appointment_id: string | null;
  created_at: string | null;
  diagnosis_codes: string[];
  encounter_id: string;
  encounter_type: string | null;
  is_signed: boolean;
  note_id: string | null;
  note_title: string | null;
  official_duration_minutes: number | null;
  official_start_time: string | null;
  procedure_codes: string[];
  provider_name: string | null;
  service_date: string | null;
  status: string;
  summary: string | null;
};
export type PatientPageV3EncounterListResponse = {
  items: PatientPageV3EncounterRow[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
};
export type UnifiedEncounterWorklistActions = {
  claim_href?: string | null;
  patient_billing_href?: string | null;
  primary_href: string;
};
export type UnifiedEncounterWorklistAge = {
  anchor?: string | null;
  days?: number | null;
  label: string;
};
export type UnifiedEncounterWorklistClaim = {
  claim_type?: string | null;
  frequency_code?: string | null;
  id?: string | null;
  parent_claim_id?: string | null;
  status?: string | null;
  submitted_at?: string | null;
  superseded_by_claim_id?: string | null;
  total_charge_cents?: number | null;
};
export type UnifiedEncounterFlowAction = {
  label: string;
  owner: string;
  severity: "info" | "warning" | "error";
};
export type FlowSourceRef = {
  id: string;
  type: string;
};
export type UnifiedEncounterFlowStage = {
  attention?: "none" | "info" | "warning" | "error";
  attention_reason?: string | null;
  completed_at?: string | null;
  display_label: string;
  key: "schedule" | "support" | "sign" | "submit" | "settle";
  source_refs?: FlowSourceRef[];
  state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  summary?: string | null;
};
export type UnifiedEncounterWorklistFlow = {
  active_stage: "schedule" | "support" | "sign" | "submit" | "settle";
  active_state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  conflicts?: {
    [key: string]: any;
  }[];
  primary_action?: UnifiedEncounterFlowAction | null;
  stages: UnifiedEncounterFlowStage[];
};
export type UnifiedEncounterIdentityBadge = {
  icon?: string | null;
  key: string;
  label: string;
  tooltip?: string | null;
};
export type UnifiedEncounterWorklistIdentity = {
  badges?: UnifiedEncounterIdentityBadge[];
  billing_codes_label?: string;
  coverage_kind?: string | null;
  encounter_id: string;
  is_self_pay?: boolean;
  member_id?: string | null;
  patient_id?: string | null;
  patient_name: string;
  payer_name: string;
  payer_uuid?: string | null;
  provider_id?: string | null;
  provider_license_label?: string | null;
  provider_name: string;
  service_date?: string | null;
  service_label: string;
};
export type UnifiedEncounterWorklistActivity = {
  at?: string | null;
  kind?: string | null;
  label: string;
  relative_label: string;
  source_id?: string | null;
  source_type?: string | null;
};
export type UnifiedEncounterWorklistMoneyCharge = {
  charged_cents?: number;
  expected_cents?: number | null;
  expected_label?: string | null;
};
export type UnifiedEncounterWorklistPatientResponsibility = {
  collected_cents?: number;
  confirmed_cents?: number;
  credit_cents?: number;
  estimated_cents?: number;
  outstanding_cents?: number;
};
export type UnifiedEncounterWorklistMoneyReconciliation = {
  active_invoice_cents?: number;
  active_invoice_ids?: string[];
  collected_cents?: number;
  confirmed_cents?: number;
  confirmed_line_ids?: string[];
  credit_cents?: number;
  estimate_line_ids?: string[];
  estimated_cents?: number;
  explanation?: string | null;
  headline?: string | null;
  payment_entry_ids?: string[];
  recommended_action?: string | null;
  remaining_due_cents?: number;
  stale_invoice_ids?: string[];
  state: string;
};
export type UnifiedEncounterWorklistMoneySecondary = {
  amount_cents?: number;
  kind: string;
  label: string;
};
export type UnifiedEncounterWorklistMoney = {
  amount_cents?: number;
  charge?: UnifiedEncounterWorklistMoneyCharge | null;
  expected_allowed_cents?: number | null;
  expected_allowed_label?: string | null;
  expected_collection_cents?: number | null;
  kind: string;
  label: string;
  patient_responsibility?: UnifiedEncounterWorklistPatientResponsibility | null;
  reconciliation?: UnifiedEncounterWorklistMoneyReconciliation | null;
  secondary?: UnifiedEncounterWorklistMoneySecondary | null;
  undercharge_risk?: boolean;
};
export type UnifiedEncounterWorklistSignal = {
  detail?: string | null;
  label: string;
  owner: "front_desk" | "clinician" | "biller" | "payer" | "patient" | "none";
  severity: "info" | "warning" | "error" | "success";
  stale?: boolean;
  work_state: "all" | "action" | "waiting" | "clear";
};
export type UnifiedEncounterWorklistSupport = {
  eligibility_snapshot_id?: string | null;
  readiness?: string | null;
  readiness_label?: string | null;
  status?: string | null;
};
export type UnifiedEncounterWorklistItem = {
  actions: UnifiedEncounterWorklistActions;
  age: UnifiedEncounterWorklistAge;
  /** Whether this encounter's patient is flagged to bill with JotPsych */
  bill_with_jotpsych_resolved?: boolean;
  claim: UnifiedEncounterWorklistClaim;
  encounter_id: string;
  flow: UnifiedEncounterWorklistFlow;
  id: string;
  identity: UnifiedEncounterWorklistIdentity;
  last_activity: UnifiedEncounterWorklistActivity;
  money: UnifiedEncounterWorklistMoney;
  /** The row's concrete next step, matching the values accepted by the next_step query filter. None on a database that predates the GDN-2769 migration. */
  next_step?:
    | (
        | "monitor_visit"
        | "verify_coverage"
        | "sign_note"
        | "create_claim"
        | "review_claim"
        | "track_payer"
        | "send_invoice"
        | "collect_balance"
        | "track_settlement"
        | "done"
      )
    | null;
  provenance?: {
    [key: string]: any;
  };
  signal: UnifiedEncounterWorklistSignal;
  support: UnifiedEncounterWorklistSupport;
};
export type PatientPageV3EncounterBillingResponse = {
  items: UnifiedEncounterWorklistItem[];
};
